import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import UserService from "../../services/user-service";
import { colors } from "../../views/Landing";
import { useSelector } from "react-redux";
import { themModeSelector } from "../../redux/selectors/AuthSelectors";

export const ExpenseTimeBreakdownChart = ({
  data = [],
  categories = [],
  average,
  color,
  viewGoal,
  expenseCap,
}: any) => {
  const { isDarkMode } = useSelector(themModeSelector);
  const series = [
    {
      name: "Average",
      data: data,
      color: color,
    },
    {
      name: viewGoal && expenseCap !== 0 ? "Goal" : " ",
      data: Array.from(
        { length: data.length },
        (x) => viewGoal && expenseCap !== 0 && expenseCap
      ),
      color: viewGoal && expenseCap !== 0 ? "#41c175" : " ",
    },
  ];

  const options = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: true,
      },
      toolbar: {
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: true,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "straight",
      dashArray: [0, 8],
    },
    title: {
      text: "Expenses ($)",
      align: "left",
    },
    grid: {
      row: {
        colors: [isDarkMode ? "#fff" : "#f3f3f3", "transparent"],
        opacity: 0.8,
      },
    },
    colors: [series[1].color],
    xaxis: {
      categories: categories,
      tooltip: {
        enabled: false,
      },
    },
    annotations: {
      xaxis: [
        {
          x: categories.length == 1 && categories[0],
          borderColor: "#00E396",
          label: {
            borderColor: "#00E396",
            style: {
              color: "#fff",
              background: "#00E396",
            },
          },
        },
      ],
    },

    yaxis: {
      labels: {
        formatter: function (val, index) {
          return val.toLocaleString();
        },
      },
    },
    tooltip: {
      custom: function ({
        series,
        seriesIndex,
        dataPointIndex,
        w: {
          globals: { categoryLabels },
        },
      }) {
        const isHigher = series[seriesIndex][dataPointIndex] < average;
        const color = isHigher ? "#eb5757" : "#41c175";
        return `<div>
                   <div style=' box-shadow: 0px 0px 10px #e0e0e0;
  overflow: hidden;
  border-radius: 10px;
  width: 15vw;
  color: #71777d !important;'>
                    <div style='background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  padding: 10px 5px 0px 5px;
  border-bottom: 1px solid #d1d1d1;'>
                      <div style='  color: #343434;
  font-size: 18px;
  font-weight: bold;
  padding: 5px;'>${categoryLabels[dataPointIndex]}</div>
                      <div
                       style='  color: ${color};
  font-weight: bold;
  font-size: 18px;
  '
                      >
                       ${series[seriesIndex][dataPointIndex].toLocaleString(
                         "en-US",
                         { style: "currency", currency: "USD" }
                       )}
                      </div>
                    </div>
                    <div style='  background-color: #ffffff;
  font-size: 18px;
  padding: 10px;     white-space: pre-line;'> Your expense
  is <span
                        style='  color: ${color};
  font-weight: bold;
  font-size: 18px;
  '

                      >${isHigher ? "lower" : "higher"}</span> than
                       average: <span style="color: #343434;
  font-weight: bold;
  padding-left: 5px;">  ${`${Math.abs(
    Number((average - series[seriesIndex][dataPointIndex]).toFixed(2))
  ).toLocaleString("en-US", { style: "currency", currency: "USD" })}`}   </span>
                    </div>
                  </div>
</div>`;
      },
    },
  };

  return (
    <div className="w-100">
      <Chart
        // @ts-ignore
        options={options}
        series={series}
        type="line"
        height={400}
      />
    </div>
  );
};

const ExpenseTrackerChart = ({ data }) => {
  const [expansion, setExpansion] = useState(true);
  const options = {
    chart: {
      width: 300,
      type: "pie",
      events: {
        click: function (event, chartContext, config) {
          setExpansion(true);
        },
        mouseLeave: function (event, chartContext, config) {
          setExpansion(false);
        },
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: expansion,
      },
    },
    colors: data.map((item) => item.color),
    labels: data.map((d) => d.label),
    states: {
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
          value: 0,
        },
      },
    },
    tooltip: {
      y: {
        formatter: function (
          value,
          { series, seriesIndex, dataPointIndex, w }
        ) {
          return value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <div>
      <Chart
        // @ts-ignore
        options={options}
        series={data.map((d) => d.subLabel)}
        type="pie"
        height={300}
      />
    </div>
  );
};

export default ExpenseTrackerChart;
